import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Tik from '../../assets/images/icons/tiktok-blanco.png';
import { useState } from 'react';

function TagSocial() {

    const [boton, setBoton] = useState (false);

    const redes = () => {
        setBoton (!boton);
    } 


  return (
    <div className={boton ? 'container-tag-main': "hidden"}>
        <button onClick={redes}>
      <FacebookIcon sx={{ color: 'white' }}/>
      <PinterestIcon sx={{ color: 'white' }}/>
      <LinkedInIcon sx={{ color: 'white' }}/>
      <InstagramIcon sx={{ color: 'white' }}/>
      <YouTubeIcon sx={{ color: 'white' }}/>
      <img src={Tik} alt="" />
      </button>
    </div>
  )
}

export default TagSocial
